import Swal, { SweetAlertOptions } from 'sweetalert2';

const BASE: SweetAlertOptions = {
  reverseButtons: true,
  confirmButtonText: 'OK',
  cancelButtonText: 'Annuler',
};

export const SwalUtils = {

  success(title: string, text: string, options?: SweetAlertOptions) {
    return Swal.fire({
      ...BASE,
      icon: 'success',
      title,
      text,
      confirmButtonColor: '#16a34a',
      ...options,
    } as SweetAlertOptions);
  },

  error(title: string, text: string, options?: SweetAlertOptions) {
    return Swal.fire({
      ...BASE,
      icon: 'error',
      title,
      text,
      confirmButtonColor: '#dc2626',
      ...options,
    } as SweetAlertOptions);
  },

  confirm(title: string, text: string, confirmButtonText: string, options?: SweetAlertOptions) {
    return Swal.fire({
      ...BASE,
      icon: 'question',
      title,
      text,
      showCancelButton: true,
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#6b7280',
      confirmButtonText,
      ...options,
    } as SweetAlertOptions);
  },

  confirmGreen(title: string, text: string, confirmButtonText: string, options?: SweetAlertOptions) {
    return Swal.fire({
      ...BASE,
      icon: 'question',
      title,
      text,
      showCancelButton: true,
      confirmButtonColor: '#16a34a',
      cancelButtonColor: '#6b7280',
      confirmButtonText,
      ...options,
    } as SweetAlertOptions);
  },
};
